export default __webpack_public_path__ + "static/media/arrow-clockwise.6a2d2fe6.svg";